<template>
    <div>
        <div class="text-subtitle1">Discount Code</div>
        <p>If you have a discount code or promotional code, enter it here.</p>
        <div class="row">
            <q-input outlined dense
                     label="Discount Code" stack-label
                     autocomplete="off"
                     v-model.trim="discountCode"
                     :loading="isDiscountCodeValidPending"
                     :error-message="isValidDiscountCodeErrorMessage"
                     :error="!isValidDiscountCode"
                     @change="checkDiscountCodeValid()"
                     class="col-xs-12 col-md-6"
                     hide-bottom-space>
                <template v-slot:append>
                    <q-icon v-if="showCheck" name="mdi-check-bold" color="positive" />
                </template>
            </q-input>
        </div>
        <div v-if="discountCodeObj && isValidDiscountCode" class="row q-my-xs q-pl-sm q-ml-xs text-positive text-caption">
            Discount Amount: {{ calculateDiscountAmount | currency }}
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        name: 'validate-discount-code',
        props: {
            product: Object,
            formDiscountCode: String,
        },
        data() {
            return {
                showCheck: false,
                discountCode: '',
                discountCodeObj: null,
                isValidDiscountCode: true,
                isValidDiscountCodeErrorMessage: '',
            }
        },
        methods: {
            clearError() {
                this.showCheck = false
                this.isValidDiscountCode = true
                this.isValidDisounctCodeErrorMessage = ''
                this.discountCodeObj = null
            },
            checkDiscountCodeValid() {
                this.clearError()
                if (this.discountCode && this.product) {
                    this.$store.dispatch('validateDiscountCode', this.discountCode).then(() => {
                        if (typeof this.isDiscountCodeValidData !== 'undefined') {
                            this.discountCodeObj = this.isDiscountCodeValidData
                            if (!this.discountCodeObj) {
                                this.isValidDiscountCodeErrorMessage = 'The discount code \'' + this.discountCode + '\' is invalid'
                                this.isValidDiscountCode = false
                                this.discountCode = ''
                                this.$emit('updateDiscountCode', '')
                            }
                            else if (this.discountCodeObj.validProducts.includes(this.product.id)) {
                                if (!this.discountCodeObj.used) {
                                    this.isValidDiscountCode = true
                                    this.showCheck = true
                                    this.$emit('updateDiscountCode', this.discountCode)
                                }
                                else {
                                    this.isValidDiscountCodeErrorMessage = 'The discount code \'' + this.discountCode + '\' has already been used'
                                    this.isValidDiscountCode = false
                                    this.discountCode = ''
                                    this.$emit('updateDiscountCode', '')
                                }
                            }
                            else {
                                this.isValidDiscountCodeErrorMessage = 'The discount code \'' + this.discountCode + '\' is not valid for the selected product'
                                this.isValidDiscountCode = false
                                this.discountCode = ''
                                this.$emit('updateDiscountCode', '')
                            }
                        }
                    })
                }
            },

        },
        computed: {
            ...mapState([
                'isDiscountCodeValidPending',
                'isDiscountCodeValidData',
            ]),
            cart() { return this.$store.getters.cart },
            calculateDiscountAmount() {
                if (this.product && this.discountCodeObj && this.isValidDiscountCode) {
                    if (this.discountCodeObj.valuePercent) {
                        if (this.cart.currency == 1) return this.product.listPriceCDN * this.discountCodeObj.valuePercent / 100
                        else return this.product.listPriceUS * this.discountCodeObj.valuePercent / 100
                    }
                    if (this.cart.currency == 1) return this.discountCodeObj.valueCDN
                    else return this.discountCodeObj.valueUS
                }
                return 0
            },
        },
        watch: {
            product(newVal) {
                if (newVal) {
                    if (this.discountCode) {
                        if (this.discountCodeObj.validProducts.includes(newVal.id)) {
                            if (!this.discountCodeObj.used) {
                                this.isValidDiscountCode = true
                                this.showCheck = true
                                this.$emit('updateDiscountCode', this.discountCode)
                            }
                            else {
                                this.isValidDiscountCodeErrorMessage = 'The discount code \'' + this.discountCode + '\' has already been used'
                                this.isValidDiscountCode = false
                                this.discountCode = ''
                                this.$emit('updateDiscountCode', '')
                            }
                        }
                        else {
                            this.isValidDiscountCodeErrorMessage = 'The discount code \'' + this.discountCode + '\' is not valid for the selected product'
                            this.isValidDiscountCode = false
                            this.showCheck = false
                            this.discountCode = ''
                            this.$emit('updateDiscountCode', '')
                        }
                    }
                    else {
                        this.clearError()
                    }
                }
            }
        },
        created() {
            if (this.formDiscountCode) {
                this.discountCode = this.formDiscountCode
                this.checkDiscountCodeValid()
            }

        }
    }
</script>
